import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Time: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Announcement = {
  __typename?: 'Announcement';
  active: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum AnyOrAllType {
  All = 'ALL',
  Any = 'ANY'
}

export enum AvailabilityStatus {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE'
}

export type Booking = {
  __typename?: 'Booking';
  chatRoom?: Maybe<ChatRoom>;
  coupon?: Maybe<Coupon>;
  couponCode?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<BookingDetail>>;
  didAttend?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  group: Group;
  guests?: Maybe<Array<Guest>>;
  id: Scalars['ID']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  leadGuest?: Maybe<Guest>;
  paymentAmount: Scalars['Float']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pickupLocation?: Maybe<PickupLocation>;
  repeaterCoupon?: Maybe<Coupon>;
  review?: Maybe<Review>;
  reviewRating?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  whenFourOrFiveStarsClicked?: Maybe<Scalars['DateTime']['output']>;
  whereReviewed?: Maybe<Scalars['String']['output']>;
};


export type BookingPaymentAmountArgs = {
  currency?: InputMaybe<Currency>;
};

export type BookingDetail = {
  __typename?: 'BookingDetail';
  productPrice: ProductPrice;
  quantity: Scalars['Int']['output'];
  unitAmount: Scalars['Float']['output'];
};


export type BookingDetailUnitAmountArgs = {
  currency: Currency;
};

export type CancelBookingInput = {
  bookingId: Scalars['ID']['input'];
  cancellationReason: Scalars['String']['input'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  backofficeUserId?: Maybe<Scalars['ID']['output']>;
  body: Scalars['String']['output'];
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['ID']['output']>;
  chatRoomId: Scalars['ID']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<ChatMessageEvent>;
  eventId?: Maybe<Scalars['ID']['output']>;
  guide?: Maybe<Guide>;
  guideId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Array<ChatMessageMedia>>;
};

export type ChatMessageEvent = {
  __typename?: 'ChatMessageEvent';
  bookingId?: Maybe<Scalars['ID']['output']>;
  created: Scalars['DateTime']['output'];
  groupId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type ChatMessageMedia = {
  __typename?: 'ChatMessageMedia';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  messageId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ChatMessagesResponse = {
  __typename?: 'ChatMessagesResponse';
  hasMore: Scalars['Boolean']['output'];
  messages: Array<ChatMessage>;
  totalCount: Scalars['Int']['output'];
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['ID']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  guide?: Maybe<Guide>;
  guideId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export enum ChatRoomType {
  Booking = 'BOOKING',
  Guide = 'GUIDE'
}

export type CloudinaryFile = {
  __typename?: 'CloudinaryFile';
  folder: Scalars['String']['output'];
  format: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  documentUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Coupon = {
  __typename?: 'Coupon';
  amount: Scalars['Float']['output'];
  availableFrom: Scalars['DateTime']['output'];
  availableUntil?: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['String']['output'];
  currency?: Maybe<Currency>;
  type: CouponType;
};


export type CouponAmountArgs = {
  currency?: InputMaybe<Currency>;
};

export enum CouponType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type CreateBookingInput = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  email: Scalars['String']['input'];
  guests: Array<GuestInput>;
  guideId?: InputMaybe<Scalars['ID']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  optInMailingList: Scalars['Boolean']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupLocation?: InputMaybe<PickupLocationInput>;
  priceTypes: Array<PriceTypeInput>;
  productId: Scalars['ID']['input'];
  specialRequests?: InputMaybe<Scalars['String']['input']>;
  time: Scalars['Time']['input'];
};

export type CreateReviewInput = {
  bookingId: Scalars['ID']['input'];
  image?: InputMaybe<ImageUrlOrFile>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  stars: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type CreateStripePaymentInput = {
  bookingId: Scalars['ID']['input'];
};

export type CreateStripePaymentResponse = {
  __typename?: 'CreateStripePaymentResponse';
  clientSecret: Scalars['String']['output'];
};

export enum Currency {
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Cny = 'CNY',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Ils = 'ILS',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Myr = 'MYR',
  Nzd = 'NZD',
  Php = 'PHP',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Twd = 'TWD',
  Usd = 'USD'
}

export type DietaryRestriction = {
  __typename?: 'DietaryRestriction';
  diet: Scalars['String']['output'];
  isPossible: YesNoLimited;
  memo?: Maybe<Scalars['String']['output']>;
};

export type EditWaitingListInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contacted?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['Date']['input'];
  groupSize: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  untilDate: Scalars['Date']['input'];
};

export type EditWaitingListResponse = {
  __typename?: 'EditWaitingListResponse';
  overlappingWaitingLists?: Maybe<Array<WaitingList>>;
  waitingList: WaitingList;
};

export type EditWaitingListUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  waitingLists?: InputMaybe<Array<EditWaitingListInput>>;
};

export type Faq = {
  __typename?: 'Faq';
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  questionsAndAnswers?: Maybe<Array<Maybe<QuestionAndAnswer>>>;
};

export type FaqsInput = {
  faqId?: InputMaybe<Scalars['ID']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Platform>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FaqsResult = {
  __typename?: 'FaqsResult';
  records: Array<Faq>;
  totalCategories: Scalars['Int']['output'];
};

export type FeaturedBanner = {
  __typename?: 'FeaturedBanner';
  created: Scalars['DateTime']['output'];
  ctaText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  pageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FixedPrice = {
  __typename?: 'FixedPrice';
  amount: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

export enum Gender {
  Female = 'female',
  Male = 'male',
  Other = 'other'
}

export type GeoLocation = {
  __typename?: 'GeoLocation';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type GeoLocationInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type GoogleMapsQuery = {
  __typename?: 'GoogleMapsQuery';
  created: Scalars['DateTime']['output'];
  geoLocation?: Maybe<GeoLocation>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
};

export type GoogleMapsQueryInput = {
  geoLocation?: InputMaybe<GeoLocationInput>;
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type Group = {
  __typename?: 'Group';
  date: Scalars['Date']['output'];
  faces: Array<Scalars['String']['output']>;
  guideAssignments: Array<GuideAssignment>;
  guides: Array<Guide>;
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  mainGuide?: Maybe<Guide>;
  maxPeople: Scalars['Int']['output'];
  media: Array<GroupMedia>;
  product: Product;
  time: Scalars['Time']['output'];
};

export type GroupMedia = {
  __typename?: 'GroupMedia';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Guest = {
  __typename?: 'Guest';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

export type GuestInput = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};

export type Guide = {
  __typename?: 'Guide';
  id: Scalars['ID']['output'];
  introVideo?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Language>>;
  media?: Maybe<Array<GuideMedia>>;
  nickName: Scalars['String']['output'];
  numCustomers?: Maybe<Scalars['Int']['output']>;
  numTours?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<GuideProduct>>;
  profilePic?: Maybe<Scalars['String']['output']>;
  reviewSummary?: Maybe<GuideReviewSummary>;
  reviews?: Maybe<ReviewsResult>;
  translation?: Maybe<GuideTranslation>;
};


export type GuideReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type GuideTranslationArgs = {
  lang: Iso639;
};

export type GuideApplicationInput = {
  age: Scalars['Int']['input'];
  countryCode: Scalars['String']['input'];
  daysAvailablePerMonth: Scalars['String']['input'];
  email: Scalars['String']['input'];
  englishLevel: LanguageLevel;
  fullName: Scalars['String']['input'];
  gender: Gender;
  howDidYouHearAboutMt: Scalars['String']['input'];
  introductionVideoUrl?: InputMaybe<Scalars['String']['input']>;
  japaneseLevel: LanguageLevel;
  locationId: Scalars['String']['input'];
  preferredTours?: InputMaybe<Array<Scalars['String']['input']>>;
  questionPresentationVideoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GuideAssignment = {
  __typename?: 'GuideAssignment';
  guide: Guide;
  lastKnownLocation?: Maybe<LastKnownLocation>;
  role: Scalars['String']['output'];
};

export type GuideMedia = {
  __typename?: 'GuideMedia';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GuideProduct = {
  __typename?: 'GuideProduct';
  firstAvailableDateTime?: Maybe<Scalars['DateTime']['output']>;
  product: Product;
};

export type GuideReviewSummary = {
  __typename?: 'GuideReviewSummary';
  average?: Maybe<Scalars['Float']['output']>;
  guideId: Scalars['ID']['output'];
  numReviews: Scalars['Int']['output'];
};

export type GuideTranslation = {
  __typename?: 'GuideTranslation';
  description?: Maybe<Scalars['String']['output']>;
  hobbies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  language: Iso639;
};

export type GuidesInput = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationSlug?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderField?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};

export type HtmlContent = {
  __typename?: 'HTMLContent';
  html: Scalars['String']['output'];
};

export type ImageUrlOrFile = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type Inquiry = {
  __typename?: 'Inquiry';
  bookingId?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  companyUrl?: Maybe<Scalars['String']['output']>;
  countryOfResidence?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isConnectedToBokun?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfGuests?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  requestedTourDate?: Maybe<Scalars['Date']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  typeOfPartnership?: Maybe<Scalars['String']['output']>;
  typeOfPromotion?: Maybe<Scalars['String']['output']>;
};

export enum Iso639 {
  En = 'en',
  Jp = 'jp',
  Ko = 'ko',
  Th = 'th',
  Zh = 'zh',
  ZhTw = 'zh_tw'
}

export type Language = {
  __typename?: 'Language';
  iso639_1: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum LanguageLevel {
  Conversational = 'conversational',
  Fluent = 'fluent',
  Intermediate = 'intermediate'
}

export type LastKnownLocation = {
  __typename?: 'LastKnownLocation';
  accuracy?: Maybe<Scalars['Float']['output']>;
  dateTime: Scalars['DateTime']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type Location = {
  __typename?: 'Location';
  ancestor?: Maybe<Location>;
  ancestors: Array<Location>;
  children: Array<Location>;
  country?: Maybe<Location>;
  countryId?: Maybe<Scalars['ID']['output']>;
  descendants: Array<Location>;
  destinationNames?: Maybe<Scalars['String']['output']>;
  faqs?: Maybe<Array<LocationFaq>>;
  guideRecruitmentOpen?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  locationType: LocationType;
  name: Scalars['String']['output'];
  parent?: Maybe<Location>;
  parentId?: Maybe<Scalars['ID']['output']>;
  products: Array<Product>;
  slug: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  translation: LocationTranslation;
  translations: Array<LocationTranslation>;
  videoApplicationRequired?: Maybe<Scalars['Boolean']['output']>;
};


export type LocationAncestorArgs = {
  ancestorType: LocationType;
};


export type LocationAncestorsArgs = {
  ancestorType?: InputMaybe<LocationType>;
};


export type LocationDescendantsArgs = {
  descendantType?: InputMaybe<LocationType>;
};


export type LocationFaqsArgs = {
  lang?: InputMaybe<Iso639>;
};


export type LocationTranslationArgs = {
  lang: Iso639;
};

export type LocationCenter = {
  __typename?: 'LocationCenter';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LocationFaq = {
  __typename?: 'LocationFAQ';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  locationId: Scalars['ID']['output'];
  translations?: Maybe<Array<LocationFaqTranslation>>;
};

export type LocationFaqTranslation = {
  __typename?: 'LocationFAQTranslation';
  answer: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  lang: Iso639;
  locationFaqId: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type LocationPickupZone = {
  __typename?: 'LocationPickupZone';
  center: LocationCenter;
  radius: Scalars['Float']['output'];
};

export type LocationTranslation = {
  __typename?: 'LocationTranslation';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lang: Iso639;
  locationId: Scalars['ID']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum LocationType {
  City = 'CITY',
  Country = 'COUNTRY',
  Prefecture = 'PREFECTURE',
  Province = 'PROVINCE',
  Region = 'REGION',
  State = 'STATE'
}

export type LocationsInput = {
  hasProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isRecruiting?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationTypes?: InputMaybe<Array<LocationType>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderInput>;
};

export type LocationsResponse = {
  __typename?: 'LocationsResponse';
  records: Array<Location>;
  totalRecords: Scalars['Int']['output'];
};

export type MediaCategory = {
  __typename?: 'MediaCategory';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum MediaType {
  Image = 'image',
  Video = 'video'
}

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['Boolean']['output']>;
  cancelBooking: Scalars['Boolean']['output'];
  confirmPaypalPayment: Booking;
  createBooking: Booking;
  createRepeaterCoupon?: Maybe<Scalars['Boolean']['output']>;
  createReview: Review;
  createStripePayment: CreateStripePaymentResponse;
  deleteAllWaitingLists: Array<WaitingList>;
  deleteWaitingListUser: WaitingListUser;
  deleteWaitingLists: Array<WaitingList>;
  editWaitingList: Array<WaitingList>;
  editWaitingListUser: WaitingListUser;
  rescheduleBooking: Scalars['Boolean']['output'];
  resendConfirmationEmails: Scalars['Boolean']['output'];
  saveFourOrFiveStarsClicked: Scalars['Boolean']['output'];
  saveGuideApplication: Scalars['Boolean']['output'];
  saveRedirectedForReview: Scalars['Boolean']['output'];
  saveReviewRating: Scalars['Boolean']['output'];
  saveWhereReviewed: Scalars['Boolean']['output'];
  sendChatMessage: ChatMessage;
  sendInquiry: Inquiry;
  setWaitingListActive: Scalars['Boolean']['output'];
  signContracts?: Maybe<Scalars['Boolean']['output']>;
  toggleWaitingList: Scalars['Boolean']['output'];
  updatePickupLocation: Scalars['Boolean']['output'];
  updateStripeCharge: Scalars['Boolean']['output'];
  uploadImage: CloudinaryFile;
};


export type MutationCancelBookingArgs = {
  input: CancelBookingInput;
};


export type MutationConfirmPaypalPaymentArgs = {
  country: Scalars['String']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationCreateBookingArgs = {
  input: CreateBookingInput;
};


export type MutationCreateRepeaterCouponArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationCreateStripePaymentArgs = {
  input: CreateStripePaymentInput;
};


export type MutationDeleteAllWaitingListsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWaitingListUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWaitingListsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationEditWaitingListArgs = {
  input: EditWaitingListInput;
};


export type MutationEditWaitingListUserArgs = {
  input: EditWaitingListUserInput;
};


export type MutationRescheduleBookingArgs = {
  input: RescheduleBookingInput;
};


export type MutationResendConfirmationEmailsArgs = {
  email: Scalars['String']['input'];
};


export type MutationSaveFourOrFiveStarsClickedArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationSaveGuideApplicationArgs = {
  input: GuideApplicationInput;
};


export type MutationSaveRedirectedForReviewArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationSaveReviewRatingArgs = {
  input: SaveReviewRatingInput;
};


export type MutationSaveWhereReviewedArgs = {
  input: SaveWhereReviewedInput;
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessageInput;
};


export type MutationSendInquiryArgs = {
  input: SendInquiryInput;
};


export type MutationSetWaitingListActiveArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationSignContractsArgs = {
  guideId: Scalars['ID']['input'];
  signature: Scalars['String']['input'];
};


export type MutationToggleWaitingListArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdatePickupLocationArgs = {
  input: UpdatePickupLocationInput;
};


export type MutationUpdateStripeChargeArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationUploadImageArgs = {
  file: Scalars['Upload']['input'];
  folder: Scalars['String']['input'];
};

export type NextAvailableGuidesInput = {
  limit: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderInput = {
  direction?: InputMaybe<OrderDirection>;
  field: Scalars['String']['input'];
};

export type PaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PickupLocation = {
  __typename?: 'PickupLocation';
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
  query: GoogleMapsQuery;
};

export type PickupLocationInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
  query: GoogleMapsQueryInput;
};

export enum Platform {
  GuideApp = 'GUIDE_APP',
  PartnerPortal = 'PARTNER_PORTAL',
  Storefront = 'STOREFRONT',
  VenuePortal = 'VENUE_PORTAL'
}

export type PriceTypeInput = {
  priceTypeId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type Product = {
  __typename?: 'Product';
  announcement?: Maybe<Announcement>;
  availability?: Maybe<Array<ProductAvailability>>;
  availabilityType: ProductAvailabilityType;
  cancellationLimit?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  details?: Maybe<Array<ProductDetail>>;
  dietaryRestrictions?: Maybe<Array<DietaryRestriction>>;
  displayPrice?: Maybe<ProductDisplayPrice>;
  duration: Scalars['Int']['output'];
  earliestAvailability?: Maybe<Scalars['Date']['output']>;
  faqs?: Maybe<Array<ProductFaq>>;
  featuredGuide?: Maybe<Guide>;
  googleMapsReviewUrl?: Maybe<Scalars['String']['output']>;
  hasAccomodationVehiclePickup: Scalars['Boolean']['output'];
  hasDefaultVehiclePickup: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inclusions?: Maybe<Array<ProductInclusion>>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']['output']>;
  mainImage?: Maybe<Scalars['String']['output']>;
  mainPrice?: Maybe<ProductPrice>;
  maximumInGroup?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<Array<ProductMedia>>;
  meetingPlaceGoogleMapsQuery?: Maybe<GoogleMapsQuery>;
  meetingPlaceGoogleMapsQueryId?: Maybe<Scalars['ID']['output']>;
  meetingPlaceGoogleMapsUrl?: Maybe<Scalars['String']['output']>;
  minimumInGroup?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numCustomers?: Maybe<Scalars['Int']['output']>;
  pickupLocationZone?: Maybe<LocationPickupZone>;
  poster?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Array<ProductPrice>>;
  privatePrices?: Maybe<Array<ProductPrivatePrice>>;
  recentPhotos?: Maybe<Array<Scalars['String']['output']>>;
  reviewLocations?: Maybe<Array<ProductReviewLocation>>;
  reviewSummary?: Maybe<ProductReviewSummary>;
  reviews?: Maybe<ReviewsResult>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  translation?: Maybe<ProductTranslation>;
  translations?: Maybe<Array<ProductTranslation>>;
  tripadvisorReviewUrl?: Maybe<Scalars['String']['output']>;
  youtubes?: Maybe<Array<ProductYouTube>>;
};


export type ProductAvailabilityArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  timeRanges?: InputMaybe<Array<TimeRangeEnum>>;
  untilDate?: InputMaybe<Scalars['Date']['input']>;
};


export type ProductDisplayPriceArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductEarliestAvailabilityArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  untilDate?: InputMaybe<Scalars['Date']['input']>;
};


export type ProductFaqsArgs = {
  lang?: InputMaybe<Iso639>;
};


export type ProductMainPriceArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductPricesArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductPrivatePricesArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductTranslationArgs = {
  lang: Iso639;
};

export type ProductAvailability = {
  __typename?: 'ProductAvailability';
  date: Scalars['Date']['output'];
  status: AvailabilityStatus;
  timeSlots?: Maybe<Array<ProductAvailabilityTime>>;
};

export type ProductAvailabilityGroup = {
  __typename?: 'ProductAvailabilityGroup';
  guides: Array<Guide>;
  id?: Maybe<Scalars['ID']['output']>;
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  seatsAvailable: Scalars['Int']['output'];
};

export type ProductAvailabilityTime = {
  __typename?: 'ProductAvailabilityTime';
  groups?: Maybe<Array<ProductAvailabilityGroup>>;
  status: AvailabilityStatus;
  time: Scalars['Time']['output'];
};

export enum ProductAvailabilityType {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  PublicAndPrivate = 'PUBLIC_AND_PRIVATE'
}

export type ProductCollection = {
  __typename?: 'ProductCollection';
  additions?: Maybe<Array<Product>>;
  anyOrAllTags: AnyOrAllType;
  content?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  listDescription: Scalars['String']['output'];
  listTitle: Scalars['String']['output'];
  locations?: Maybe<Array<Location>>;
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  omissions?: Maybe<Array<Product>>;
  products: ProductCollectionProductsResult;
  slug: Scalars['String']['output'];
  tags?: Maybe<Array<Tag>>;
  title: Scalars['String']['output'];
};


export type ProductCollectionProductsArgs = {
  input?: InputMaybe<PaginationInput>;
};

export type ProductCollectionProductsResult = {
  __typename?: 'ProductCollectionProductsResult';
  records: Array<Product>;
  totalRecords: Scalars['Int']['output'];
};

export type ProductCollectionsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCollectionsResult = {
  __typename?: 'ProductCollectionsResult';
  records: Array<ProductCollection>;
  totalRecords: Scalars['Int']['output'];
};

export type ProductDetail = {
  __typename?: 'ProductDetail';
  media: Array<ProductDetailMedia>;
  translation: ProductDetailTranslation;
};


export type ProductDetailTranslationArgs = {
  lang: Iso639;
};

export type ProductDetailMedia = {
  __typename?: 'ProductDetailMedia';
  mediaUrl: Scalars['String']['output'];
  type?: Maybe<ProductDetailMediaType>;
  typeId: Scalars['Int']['output'];
};

export type ProductDetailMediaType = {
  __typename?: 'ProductDetailMediaType';
  type?: Maybe<MediaType>;
};

export type ProductDetailTranslation = {
  __typename?: 'ProductDetailTranslation';
  lang: Iso639;
  name: Scalars['String']['output'];
  story: Scalars['String']['output'];
};

export type ProductDisplayPrice = {
  __typename?: 'ProductDisplayPrice';
  amount: Scalars['Float']['output'];
  currency: Currency;
  isGroup: Scalars['Boolean']['output'];
  originalPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProductFaq = {
  __typename?: 'ProductFAQ';
  answer: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  lang: Iso639;
  productId: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type ProductInclusion = {
  __typename?: 'ProductInclusion';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  translation: ProductInclusionTranslation;
};


export type ProductInclusionTranslationArgs = {
  lang: Iso639;
};

export type ProductInclusionTranslation = {
  __typename?: 'ProductInclusionTranslation';
  description?: Maybe<Scalars['String']['output']>;
  lang: Iso639;
  title: Scalars['String']['output'];
};

export type ProductMedia = {
  __typename?: 'ProductMedia';
  category?: Maybe<MediaCategory>;
  type: MediaType;
  url: Scalars['String']['output'];
};

export enum ProductOrderField {
  Price = 'PRICE',
  Score = 'SCORE'
}

export type ProductPrice = {
  __typename?: 'ProductPrice';
  amount: Scalars['Float']['output'];
  currency: Currency;
  excludeFromPrivateGroupCount: Scalars['Boolean']['output'];
  fixedPrices?: Maybe<Array<FixedPrice>>;
  id: Scalars['ID']['output'];
  maximumPeople: Scalars['Int']['output'];
  minimumPeople: Scalars['Int']['output'];
  originalPrice?: Maybe<Scalars['Float']['output']>;
  translation?: Maybe<ProductPriceTranslation>;
  vegetarian: Scalars['Boolean']['output'];
};


export type ProductPriceTranslationArgs = {
  lang: Iso639;
};

export type ProductPriceTranslation = {
  __typename?: 'ProductPriceTranslation';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ProductPrivatePrice = {
  __typename?: 'ProductPrivatePrice';
  id: Scalars['ID']['output'];
  minGroupSize: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
};

export type ProductReviewLocation = {
  __typename?: 'ProductReviewLocation';
  created?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  percentage: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductReviewSummary = {
  __typename?: 'ProductReviewSummary';
  average?: Maybe<Scalars['Float']['output']>;
  numReviews: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
};

export type ProductTranslation = {
  __typename?: 'ProductTranslation';
  cancellationPolicy: Scalars['String']['output'];
  featuredGuideComment?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Scalars['String']['output']>;
  included?: Maybe<Scalars['String']['output']>;
  itinerary?: Maybe<Scalars['String']['output']>;
  lang: Iso639;
  meetingPlaceDescription?: Maybe<Scalars['String']['output']>;
  meetingPlaceName?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notIncluded?: Maybe<Scalars['String']['output']>;
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

export type ProductYouTube = {
  __typename?: 'ProductYouTube';
  title: Scalars['String']['output'];
  youtubeId: Scalars['String']['output'];
};

export type ProductsInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationSlug?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderDirection?: InputMaybe<OrderDirection>;
  orderField?: InputMaybe<ProductOrderField>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProductsResult = {
  __typename?: 'ProductsResult';
  records: Array<Product>;
  totalRecords: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['Boolean']['output']>;
  booking?: Maybe<Booking>;
  chatMessages: ChatMessagesResponse;
  chatRoom?: Maybe<ChatRoom>;
  contract?: Maybe<Contract>;
  coupon?: Maybe<Coupon>;
  faqs: FaqsResult;
  featuredBanners: Array<FeaturedBanner>;
  guide?: Maybe<Guide>;
  guideGroups: Array<Group>;
  guides: Array<Guide>;
  htmlContent: HtmlContent;
  location: Location;
  locations: LocationsResponse;
  nextAvailableGuides: Array<Group>;
  product?: Maybe<Product>;
  productCollection: ProductCollection;
  productCollections: ProductCollectionsResult;
  products: ProductsResult;
  reviews: ReviewsResult;
  searchProducts: ProductsResult;
  tags: TagsResult;
  waitingListUser: WaitingListUser;
  waitingListUsers: Array<WaitingListUser>;
};


export type QueryBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatMessagesArgs = {
  bookingId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextId?: InputMaybe<Scalars['String']['input']>;
  prevId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatRoomArgs = {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  guideId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ChatRoomType>;
};


export type QueryContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCouponArgs = {
  code: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFaqsArgs = {
  input?: InputMaybe<FaqsInput>;
};


export type QueryFeaturedBannersArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  showHome?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGuideArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGuideGroupsArgs = {
  guideId: Scalars['ID']['input'];
  numGroups: Scalars['Int']['input'];
};


export type QueryGuidesArgs = {
  input: GuidesInput;
};


export type QueryHtmlContentArgs = {
  pageName: Scalars['String']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationsArgs = {
  input?: InputMaybe<LocationsInput>;
};


export type QueryNextAvailableGuidesArgs = {
  input: NextAvailableGuidesInput;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductCollectionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductCollectionsArgs = {
  input?: InputMaybe<ProductCollectionsInput>;
};


export type QueryProductsArgs = {
  input?: InputMaybe<ProductsInput>;
};


export type QueryReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchProductsArgs = {
  input?: InputMaybe<SearchProductsInput>;
};


export type QueryTagsArgs = {
  hasProducts?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWaitingListUserArgs = {
  accessKey: Scalars['ID']['input'];
};

export type QuestionAndAnswer = {
  __typename?: 'QuestionAndAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  faqCategory?: Maybe<Faq>;
  faqCategoryId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type RemoveAllWaitingListsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RescheduleBookingInput = {
  bookingId: Scalars['ID']['input'];
  isPrivate: Scalars['Boolean']['input'];
  newDate: Scalars['Date']['input'];
  newTime: Scalars['Time']['input'];
};

export type Review = {
  __typename?: 'Review';
  booking?: Maybe<Booking>;
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isApprovedImage?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Product>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  stars: Scalars['Float']['output'];
  text?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type ReviewsResult = {
  __typename?: 'ReviewsResult';
  avgStars?: Maybe<Scalars['Float']['output']>;
  records?: Maybe<Array<Review>>;
  totalRecords: Scalars['Int']['output'];
};

export type SaveReviewRatingInput = {
  bookingId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
};

export type SaveWhereReviewedInput = {
  bookingId: Scalars['ID']['input'];
  whereReviewed: Scalars['String']['input'];
};

export type SearchProductsInput = {
  fromDate: Scalars['Date']['input'];
  groupSize: Scalars['Int']['input'];
  lang?: InputMaybe<Iso639>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeRanges?: InputMaybe<Array<TimeRangeEnum>>;
  untilDate: Scalars['Date']['input'];
};

export type SendChatMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId: Scalars['ID']['input'];
  chatRoomId: Scalars['ID']['input'];
  media?: InputMaybe<Array<SendChatMessageMediaInput>>;
};

export type SendChatMessageMediaInput = {
  fileUrl: Scalars['String']['input'];
};

export type SendInquiryInput = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  companyUrl?: InputMaybe<Scalars['String']['input']>;
  countryOfResidence?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isConnectedToBokun?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  requestedTourDate?: InputMaybe<Scalars['Date']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  typeOfPartnership?: InputMaybe<Scalars['String']['input']>;
  typeOfPromotion?: InputMaybe<Scalars['String']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  translation?: Maybe<TagTranslation>;
};


export type TagTranslationArgs = {
  lang: Iso639;
};

export type TagTranslation = {
  __typename?: 'TagTranslation';
  created: Scalars['DateTime']['output'];
  lang: Iso639;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type TagsResult = {
  __typename?: 'TagsResult';
  records: Array<Tag>;
  totalRecords: Scalars['Int']['output'];
};

export enum TimeRangeEnum {
  Afternoon = 'afternoon',
  Evening = 'evening',
  Morning = 'morning'
}

export type UpdatePickupLocationInput = {
  bookingId: Scalars['ID']['input'];
  pickupLocation?: InputMaybe<PickupLocationInput>;
  sendEmailToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WaitingList = {
  __typename?: 'WaitingList';
  active: Scalars['Boolean']['output'];
  contacted: Array<Scalars['DateTime']['output']>;
  fromDate: Scalars['Date']['output'];
  groupSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  untilDate: Scalars['Date']['output'];
};

export type WaitingListUser = {
  __typename?: 'WaitingListUser';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  waitingLists: Array<WaitingList>;
};

export enum YesNoLimited {
  Limited = 'limited',
  No = 'no',
  Yes = 'yes'
}

export type BookingFieldsFragment = { __typename?: 'Booking', id: string, created: any, state: string, didAttend?: boolean | null, email?: string | null, givenName?: string | null, familyName?: string | null, paymentAmount: number, pickupLocation?: { __typename?: 'PickupLocation', address: string, name: string, query: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } } | null };

export type ChatMessageEventFieldsFragment = { __typename?: 'ChatMessageEvent', id: string, created: any, type: string, groupId?: string | null, bookingId?: string | null };

export type ChatMessageMediaFieldsFragment = { __typename?: 'ChatMessageMedia', id: string, created: any, messageId: string, type: string, url: string };

export type ChatMessageFieldsFragment = { __typename?: 'ChatMessage', id: string, created?: any | null, chatRoomId: string, bookingId?: string | null, backofficeUserId?: string | null, guideId?: string | null, eventId?: string | null, body: string };

export type ChatRoomFieldsFragment = { __typename?: 'ChatRoom', id: string, created?: any | null, type: string, bookingId?: string | null, guideId?: string | null };

export type GuideTranslationFieldsFragment = { __typename?: 'GuideTranslation', language: Iso639, description?: string | null, hobbies?: Array<string | null> | null };

export type GuideFieldsFragment = { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, introVideo?: string | null, numTours?: number | null, numCustomers?: number | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null };

export type LocationTranslationFieldsFragment = { __typename?: 'LocationTranslation', name: string, metaTitle?: string | null, metaDescription?: string | null, lang: Iso639 };

export type LocationFieldsFragment = { __typename?: 'Location', id: string, parentId?: string | null, countryId?: string | null, slug: string, timezone: string, country?: { __typename?: 'Location', id: string, name: string } | null };

export type ProductAvailabilityGroupFieldsFragment = { __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number };

export type ProductAvailabilityTimeSlotsFieldsFragment = { __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus, groups?: Array<{ __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number, isEmpty?: boolean | null, isPrivate?: boolean | null, guides: Array<{ __typename?: 'Guide', id: string, nickName: string }> }> | null }> | null };

export type ProductAvailabilityTimeFieldsFragment = { __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus };

export type ProductAvailabilityFieldsFragment = { __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus };

export type ProductCollectionProductFieldsFragment = { __typename?: 'ProductCollection', products: { __typename?: 'ProductCollectionProductsResult', records: Array<{ __typename?: 'Product', id: string, created: any, lastUpdated?: any | null, duration: number, poster?: string | null, meetingPlaceGoogleMapsUrl?: string | null, maximumInGroup?: number | null, numCustomers?: number | null, mainImage?: string | null, name?: string | null, cancellationLimit?: number | null, availabilityType: ProductAvailabilityType, translation?: { __typename?: 'ProductTranslation', lang: Iso639, name: string, headline?: string | null, highlights?: string | null, included?: string | null, notIncluded?: string | null, remarks?: string | null, meetingPlaceName?: string | null, meetingPlaceDescription?: string | null, featuredGuideComment?: string | null, itinerary?: string | null, cancellationPolicy: string, ogTitle?: string | null, ogDescription?: string | null, metaDescription?: string | null } | null, mainPrice?: { __typename?: 'ProductPrice', amount: number, currency: Currency, excludeFromPrivateGroupCount: boolean, id: string, maximumPeople: number, minimumPeople: number, originalPrice?: number | null, vegetarian: boolean } | null, reviews?: { __typename?: 'ReviewsResult', avgStars?: number | null, totalRecords: number } | null, tags?: Array<{ __typename?: 'Tag', id: string, created: any, lastUpdated?: any | null, name: string, translation?: { __typename?: 'TagTranslation', created: any, lastUpdated?: any | null, lang: Iso639, name: string } | null } | null> | null, availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus, groups?: Array<{ __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number, guides: Array<{ __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, introVideo?: string | null, numTours?: number | null, numCustomers?: number | null, translation?: { __typename?: 'GuideTranslation', language: Iso639, description?: string | null, hobbies?: Array<string | null> | null } | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null }> }> | null }> | null }> | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null }> } };

export type ProductCollectionFieldsFragment = { __typename?: 'ProductCollection', id: string, slug: string, title: string, listTitle: string, metaTitle: string, headline: string, description: string, listDescription: string, metaDescription: string, content?: string | null, imageUrl?: string | null, lastUpdated?: any | null, locations?: Array<{ __typename?: 'Location', id: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string }> | null };

export type ProductDetailMediaFieldsFragment = { __typename?: 'ProductDetailMedia', typeId: number, mediaUrl: string, type?: { __typename?: 'ProductDetailMediaType', type?: MediaType | null } | null };

export type ProductDetailTranslationFieldsFragment = { __typename?: 'ProductDetailTranslation', lang: Iso639, name: string, story: string };

export type ProductDietaryRestrictionsFieldsFragment = { __typename?: 'DietaryRestriction', diet: string, memo?: string | null, isPossible: YesNoLimited };

export type ProductDisplayPriceFieldsFragment = { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean, originalPrice?: number | null };

export type ProductFaqFieldsFragment = { __typename?: 'ProductFAQ', id: string, createdAt: any, productId: string, lang: Iso639, question: string, answer: string, index: number, imageUrl?: string | null };

export type ProductInclusionTranslationFieldsFragment = { __typename?: 'ProductInclusionTranslation', lang: Iso639, title: string, description?: string | null };

export type ProductInclusionFieldsFragment = { __typename?: 'ProductInclusion', id: string, index: number, icon?: string | null };

export type ProductMediaFieldsFragment = { __typename?: 'ProductMedia', url: string, type: MediaType, category?: { __typename?: 'MediaCategory', id: string, name: string } | null };

export type ProductPriceTranslationFieldsFragment = { __typename?: 'ProductPriceTranslation', name: string, description?: string | null };

export type ProductPriceFieldsFragment = { __typename?: 'ProductPrice', amount: number, currency: Currency, excludeFromPrivateGroupCount: boolean, id: string, maximumPeople: number, minimumPeople: number, originalPrice?: number | null, vegetarian: boolean };

export type ProductPrivatePriceFieldsFragment = { __typename?: 'ProductPrivatePrice', id: string, minGroupSize: number, price?: number | null };

export type ProductTranslationFieldsFragment = { __typename?: 'ProductTranslation', lang: Iso639, name: string, headline?: string | null, highlights?: string | null, included?: string | null, notIncluded?: string | null, remarks?: string | null, meetingPlaceName?: string | null, meetingPlaceDescription?: string | null, featuredGuideComment?: string | null, itinerary?: string | null, cancellationPolicy: string, ogTitle?: string | null, ogDescription?: string | null, metaDescription?: string | null };

export type ProductYouTubeFieldsFragment = { __typename?: 'ProductYouTube', youtubeId: string, title: string };

export type ProductFieldsFragment = { __typename?: 'Product', id: string, created: any, lastUpdated?: any | null, duration: number, poster?: string | null, meetingPlaceGoogleMapsUrl?: string | null, maximumInGroup?: number | null, numCustomers?: number | null, mainImage?: string | null, name?: string | null, cancellationLimit?: number | null, availabilityType: ProductAvailabilityType, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null };

export type ReviewFieldsFragment = { __typename?: 'Review', id: string, text?: string | null, userName?: string | null, date: any, stars: number, profileImageUrl?: string | null, imageUrl?: string | null, isApprovedImage?: boolean | null, booking?: { __typename?: 'Booking', group: { __typename?: 'Group', date: any } } | null };

export type TagTranslationFieldsFragment = { __typename?: 'TagTranslation', created: any, lastUpdated?: any | null, lang: Iso639, name: string };

export type TagFieldsFragment = { __typename?: 'Tag', id: string, created: any, lastUpdated?: any | null, name: string };

export type DeleteAllWaitingListsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAllWaitingListsMutation = { __typename?: 'Mutation', deleteAllWaitingLists: Array<{ __typename?: 'WaitingList', id: string }> };

export type DeleteWaitingListsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteWaitingListsMutation = { __typename?: 'Mutation', deleteWaitingLists: Array<{ __typename?: 'WaitingList', id: string }> };

export type EditWaitingListMutationVariables = Exact<{
  input: EditWaitingListInput;
}>;


export type EditWaitingListMutation = { __typename?: 'Mutation', editWaitingList: Array<{ __typename?: 'WaitingList', id: string, productId: string, fromDate: any, untilDate: any, groupSize: number, active: boolean, contacted: Array<any> }> };

export type EditWaitingListUserMutationVariables = Exact<{
  input: EditWaitingListUserInput;
}>;


export type EditWaitingListUserMutation = { __typename?: 'Mutation', editWaitingListUser: { __typename?: 'WaitingListUser', timeZone: string } };

export type SendChatMessageMutationVariables = Exact<{
  input: SendChatMessageInput;
}>;


export type SendChatMessageMutation = { __typename?: 'Mutation', sendChatMessage: { __typename?: 'ChatMessage', id: string, created?: any | null, chatRoomId: string, bookingId?: string | null, backofficeUserId?: string | null, guideId?: string | null, eventId?: string | null, body: string, media?: Array<{ __typename?: 'ChatMessageMedia', id: string, created: any, messageId: string, type: string, url: string }> | null } };

export type SignContractsMutationVariables = Exact<{
  guideId: Scalars['ID']['input'];
  signature: Scalars['String']['input'];
}>;


export type SignContractsMutation = { __typename?: 'Mutation', signContracts?: boolean | null };

export type ToggleWaitingListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ToggleWaitingListMutation = { __typename?: 'Mutation', toggleWaitingList: boolean };

export type GetAllCountriesQueryVariables = Exact<{
  input?: InputMaybe<LocationsInput>;
}>;


export type GetAllCountriesQuery = { __typename?: 'Query', locations: { __typename?: 'LocationsResponse', records: Array<{ __typename?: 'Location', id: string, name: string }> } };

export type GetAllLocationIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLocationIdsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationsResponse', records: Array<{ __typename?: 'Location', id: string, slug: string, country?: { __typename?: 'Location', id: string, name: string } | null }> } };

export type GetAllProductOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProductOptionsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResult', records: Array<{ __typename?: 'Product', id: string, translation?: { __typename?: 'ProductTranslation', name: string } | null, location?: { __typename?: 'Location', name: string } | null }> } };

export type GetAvailableGuidesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  lang: Iso639;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
}>;


export type GetAvailableGuidesQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus, groups?: Array<{ __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number, guides: Array<{ __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, introVideo?: string | null, numTours?: number | null, numCustomers?: number | null, translation?: { __typename?: 'GuideTranslation', language: Iso639, description?: string | null, hobbies?: Array<string | null> | null } | null, reviews?: { __typename?: 'ReviewsResult', avgStars?: number | null, totalRecords: number } | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null }> }> | null }> | null }> | null } | null };

export type GetBookingQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type GetBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: string, state: string, paymentAmount: number, currency?: string | null, email?: string | null, familyName?: string | null, givenName?: string | null, phoneNumber?: string | null, isPrivate?: boolean | null, created: any, pickupLocation?: { __typename?: 'PickupLocation', name: string, address: string, query: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } } | null, group: { __typename?: 'Group', date: any, time: any, guideAssignments: Array<{ __typename?: 'GuideAssignment', guide: { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null } }>, product: { __typename?: 'Product', minimumInGroup?: number | null, meetingPlaceGoogleMapsUrl?: string | null, poster?: string | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null, translation?: { __typename?: 'ProductTranslation', name: string, itinerary?: string | null, meetingPlaceDescription?: string | null, meetingPlaceName?: string | null } | null } } } | null };

export type GetBookingDetailsQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  currency: Currency;
  lang: Iso639;
}>;


export type GetBookingDetailsQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', details?: Array<{ __typename?: 'BookingDetail', quantity: number, unitAmount: number, productPrice: { __typename?: 'ProductPrice', excludeFromPrivateGroupCount: boolean, translation?: { __typename?: 'ProductPriceTranslation', name: string, description?: string | null } | null } }> | null } | null };

export type GetBookingWithChatRoomQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type GetBookingWithChatRoomQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: string, state: string, paymentAmount: number, currency?: string | null, email?: string | null, familyName?: string | null, givenName?: string | null, isPrivate?: boolean | null, created: any, pickupLocation?: { __typename?: 'PickupLocation', name: string, address: string, query: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } } | null, chatRoom?: { __typename?: 'ChatRoom', id: string, created?: any | null, type: string, bookingId?: string | null, guideId?: string | null } | null, group: { __typename?: 'Group', date: any, time: any, guideAssignments: Array<{ __typename?: 'GuideAssignment', role: string, guide: { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null } }>, product: { __typename?: 'Product', minimumInGroup?: number | null, meetingPlaceGoogleMapsUrl?: string | null, poster?: string | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null, translation?: { __typename?: 'ProductTranslation', name: string, itinerary?: string | null, meetingPlaceDescription?: string | null, meetingPlaceName?: string | null } | null } } } | null };

export type GetChatMessagesQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  prevId?: InputMaybe<Scalars['String']['input']>;
  nextId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChatMessagesQuery = { __typename?: 'Query', chatMessages: { __typename?: 'ChatMessagesResponse', totalCount: number, hasMore: boolean, messages: Array<{ __typename?: 'ChatMessage', id: string, created?: any | null, chatRoomId: string, bookingId?: string | null, backofficeUserId?: string | null, guideId?: string | null, eventId?: string | null, body: string, booking?: { __typename?: 'Booking', id: string, created: any, state: string, didAttend?: boolean | null, email?: string | null, givenName?: string | null, familyName?: string | null, paymentAmount: number, pickupLocation?: { __typename?: 'PickupLocation', address: string, name: string, query: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } } | null } | null, guide?: { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, introVideo?: string | null, numTours?: number | null, numCustomers?: number | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null } | null, media?: Array<{ __typename?: 'ChatMessageMedia', id: string, created: any, messageId: string, type: string, url: string }> | null }> } };

export type NextAvailableGuidesQueryVariables = Exact<{
  input: NextAvailableGuidesInput;
  lang: Iso639;
}>;


export type NextAvailableGuidesQuery = { __typename?: 'Query', nextAvailableGuides: Array<{ __typename?: 'Group', id: string, date: any, time: any, mainGuide?: { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, introVideo?: string | null, numTours?: number | null, numCustomers?: number | null, translation?: { __typename?: 'GuideTranslation', description?: string | null } | null } | null }> };

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  currency?: InputMaybe<Currency>;
  lang: Iso639;
}>;


export type GetProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', recentPhotos?: Array<string> | null, hasAccomodationVehiclePickup: boolean, hasDefaultVehiclePickup: boolean, id: string, created: any, lastUpdated?: any | null, duration: number, poster?: string | null, meetingPlaceGoogleMapsUrl?: string | null, maximumInGroup?: number | null, numCustomers?: number | null, mainImage?: string | null, name?: string | null, cancellationLimit?: number | null, availabilityType: ProductAvailabilityType, translation?: { __typename?: 'ProductTranslation', lang: Iso639, name: string, headline?: string | null, highlights?: string | null, included?: string | null, notIncluded?: string | null, remarks?: string | null, meetingPlaceName?: string | null, meetingPlaceDescription?: string | null, featuredGuideComment?: string | null, itinerary?: string | null, cancellationPolicy: string, ogTitle?: string | null, ogDescription?: string | null, metaDescription?: string | null } | null, prices?: Array<{ __typename?: 'ProductPrice', amount: number, currency: Currency, excludeFromPrivateGroupCount: boolean, id: string, maximumPeople: number, minimumPeople: number, originalPrice?: number | null, vegetarian: boolean }> | null, privatePrices?: Array<{ __typename?: 'ProductPrivatePrice', id: string, minGroupSize: number, price?: number | null }> | null, faqs?: Array<{ __typename?: 'ProductFAQ', id: string, createdAt: any, productId: string, lang: Iso639, question: string, answer: string, index: number, imageUrl?: string | null }> | null, featuredGuide?: { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, introVideo?: string | null, numTours?: number | null, numCustomers?: number | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null } | null, youtubes?: Array<{ __typename?: 'ProductYouTube', youtubeId: string, title: string }> | null, reviews?: { __typename?: 'ReviewsResult', avgStars?: number | null, totalRecords: number } | null, tags?: Array<{ __typename?: 'Tag', id: string, created: any, lastUpdated?: any | null, name: string, translation?: { __typename?: 'TagTranslation', created: any, lastUpdated?: any | null, lang: Iso639, name: string } | null } | null> | null, media?: Array<{ __typename?: 'ProductMedia', url: string, type: MediaType, category?: { __typename?: 'MediaCategory', id: string, name: string } | null }> | null, details?: Array<{ __typename?: 'ProductDetail', media: Array<{ __typename?: 'ProductDetailMedia', typeId: number, mediaUrl: string, type?: { __typename?: 'ProductDetailMediaType', type?: MediaType | null } | null }>, translation: { __typename?: 'ProductDetailTranslation', lang: Iso639, name: string, story: string } }> | null, location?: { __typename?: 'Location', id: string, parentId?: string | null, countryId?: string | null, slug: string, timezone: string, translation: { __typename?: 'LocationTranslation', name: string, metaTitle?: string | null, metaDescription?: string | null, lang: Iso639 }, country?: { __typename?: 'Location', id: string, name: string } | null } | null, inclusions?: Array<{ __typename?: 'ProductInclusion', id: string, index: number, icon?: string | null, translation: { __typename?: 'ProductInclusionTranslation', lang: Iso639, title: string, description?: string | null } }> | null, dietaryRestrictions?: Array<{ __typename?: 'DietaryRestriction', diet: string, memo?: string | null, isPossible: YesNoLimited }> | null, pickupLocationZone?: { __typename?: 'LocationPickupZone', radius: number, center: { __typename?: 'LocationCenter', lat: number, lng: number } } | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null } | null };

export type GetProductAvailabilitiesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  lang: Iso639;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
}>;


export type GetProductAvailabilitiesQuery = { __typename?: 'Query', product?: { __typename?: 'Product', availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus, groups?: Array<{ __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number, guides: Array<{ __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, introVideo?: string | null, numTours?: number | null, numCustomers?: number | null, translation?: { __typename?: 'GuideTranslation', language: Iso639, description?: string | null, hobbies?: Array<string | null> | null } | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null }> }> | null }> | null }> | null } | null };

export type GetProductCollectionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
  currency: Currency;
  lang: Iso639;
}>;


export type GetProductCollectionQuery = { __typename?: 'Query', productCollection: { __typename?: 'ProductCollection', id: string, slug: string, title: string, listTitle: string, metaTitle: string, headline: string, description: string, listDescription: string, metaDescription: string, content?: string | null, imageUrl?: string | null, lastUpdated?: any | null, locations?: Array<{ __typename?: 'Location', id: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string }> | null, products: { __typename?: 'ProductCollectionProductsResult', records: Array<{ __typename?: 'Product', id: string, created: any, lastUpdated?: any | null, duration: number, poster?: string | null, meetingPlaceGoogleMapsUrl?: string | null, maximumInGroup?: number | null, numCustomers?: number | null, mainImage?: string | null, name?: string | null, cancellationLimit?: number | null, availabilityType: ProductAvailabilityType, translation?: { __typename?: 'ProductTranslation', lang: Iso639, name: string, headline?: string | null, highlights?: string | null, included?: string | null, notIncluded?: string | null, remarks?: string | null, meetingPlaceName?: string | null, meetingPlaceDescription?: string | null, featuredGuideComment?: string | null, itinerary?: string | null, cancellationPolicy: string, ogTitle?: string | null, ogDescription?: string | null, metaDescription?: string | null } | null, mainPrice?: { __typename?: 'ProductPrice', amount: number, currency: Currency, excludeFromPrivateGroupCount: boolean, id: string, maximumPeople: number, minimumPeople: number, originalPrice?: number | null, vegetarian: boolean } | null, reviews?: { __typename?: 'ReviewsResult', avgStars?: number | null, totalRecords: number } | null, tags?: Array<{ __typename?: 'Tag', id: string, created: any, lastUpdated?: any | null, name: string, translation?: { __typename?: 'TagTranslation', created: any, lastUpdated?: any | null, lang: Iso639, name: string } | null } | null> | null, availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus, groups?: Array<{ __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number, guides: Array<{ __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, introVideo?: string | null, numTours?: number | null, numCustomers?: number | null, translation?: { __typename?: 'GuideTranslation', language: Iso639, description?: string | null, hobbies?: Array<string | null> | null } | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null }> }> | null }> | null }> | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null }> } } };

export type GetProductCollectionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  currency: Currency;
  lang: Iso639;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
}>;


export type GetProductCollectionsQuery = { __typename?: 'Query', productCollections: { __typename?: 'ProductCollectionsResult', totalRecords: number, records: Array<{ __typename?: 'ProductCollection', id: string, slug: string, title: string, listTitle: string, metaTitle: string, headline: string, description: string, listDescription: string, metaDescription: string, content?: string | null, imageUrl?: string | null, lastUpdated?: any | null, locations?: Array<{ __typename?: 'Location', id: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string }> | null, products: { __typename?: 'ProductCollectionProductsResult', records: Array<{ __typename?: 'Product', id: string, created: any, lastUpdated?: any | null, duration: number, poster?: string | null, meetingPlaceGoogleMapsUrl?: string | null, maximumInGroup?: number | null, numCustomers?: number | null, mainImage?: string | null, name?: string | null, cancellationLimit?: number | null, availabilityType: ProductAvailabilityType, translation?: { __typename?: 'ProductTranslation', lang: Iso639, name: string, headline?: string | null, highlights?: string | null, included?: string | null, notIncluded?: string | null, remarks?: string | null, meetingPlaceName?: string | null, meetingPlaceDescription?: string | null, featuredGuideComment?: string | null, itinerary?: string | null, cancellationPolicy: string, ogTitle?: string | null, ogDescription?: string | null, metaDescription?: string | null } | null, mainPrice?: { __typename?: 'ProductPrice', amount: number, currency: Currency, excludeFromPrivateGroupCount: boolean, id: string, maximumPeople: number, minimumPeople: number, originalPrice?: number | null, vegetarian: boolean } | null, reviews?: { __typename?: 'ReviewsResult', avgStars?: number | null, totalRecords: number } | null, tags?: Array<{ __typename?: 'Tag', id: string, created: any, lastUpdated?: any | null, name: string, translation?: { __typename?: 'TagTranslation', created: any, lastUpdated?: any | null, lang: Iso639, name: string } | null } | null> | null, availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus, groups?: Array<{ __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number, guides: Array<{ __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, introVideo?: string | null, numTours?: number | null, numCustomers?: number | null, translation?: { __typename?: 'GuideTranslation', language: Iso639, description?: string | null, hobbies?: Array<string | null> | null } | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null }> }> | null }> | null }> | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null }> } }> } };

export type GetProductReviewsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductReviewsQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, created: any, lastUpdated?: any | null, duration: number, poster?: string | null, meetingPlaceGoogleMapsUrl?: string | null, maximumInGroup?: number | null, numCustomers?: number | null, mainImage?: string | null, name?: string | null, cancellationLimit?: number | null, availabilityType: ProductAvailabilityType, reviews?: { __typename?: 'ReviewsResult', avgStars?: number | null, totalRecords: number, records?: Array<{ __typename?: 'Review', id: string, text?: string | null, userName?: string | null, date: any, stars: number, profileImageUrl?: string | null, imageUrl?: string | null, isApprovedImage?: boolean | null, booking?: { __typename?: 'Booking', group: { __typename?: 'Group', date: any } } | null }> | null } | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null } | null };

export type GetProductsQueryVariables = Exact<{
  productIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Currency>;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  lang: Iso639;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  timeRanges?: InputMaybe<Array<TimeRangeEnum> | TimeRangeEnum>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResult', records: Array<{ __typename?: 'Product', id: string, created: any, lastUpdated?: any | null, duration: number, poster?: string | null, meetingPlaceGoogleMapsUrl?: string | null, maximumInGroup?: number | null, numCustomers?: number | null, mainImage?: string | null, name?: string | null, cancellationLimit?: number | null, availabilityType: ProductAvailabilityType, prices?: Array<{ __typename?: 'ProductPrice', amount: number, currency: Currency, excludeFromPrivateGroupCount: boolean, id: string, maximumPeople: number, minimumPeople: number, originalPrice?: number | null, vegetarian: boolean }> | null, translation?: { __typename?: 'ProductTranslation', lang: Iso639, name: string, headline?: string | null, highlights?: string | null, included?: string | null, notIncluded?: string | null, remarks?: string | null, meetingPlaceName?: string | null, meetingPlaceDescription?: string | null, featuredGuideComment?: string | null, itinerary?: string | null, cancellationPolicy: string, ogTitle?: string | null, ogDescription?: string | null, metaDescription?: string | null } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, type: MediaType, category?: { __typename?: 'MediaCategory', id: string, name: string } | null }> | null, reviews?: { __typename?: 'ReviewsResult', avgStars?: number | null, totalRecords: number } | null, tags?: Array<{ __typename?: 'Tag', id: string, created: any, lastUpdated?: any | null, name: string, translation?: { __typename?: 'TagTranslation', created: any, lastUpdated?: any | null, lang: Iso639, name: string } | null } | null> | null, mainPrice?: { __typename?: 'ProductPrice', amount: number, currency: Currency } | null, privatePrices?: Array<{ __typename?: 'ProductPrivatePrice', id: string, minGroupSize: number, price?: number | null }> | null, availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus }> | null }> | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null }> } };

export type GetSearchProductsQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  groupSize: Scalars['Int']['input'];
  lang: Iso639;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  timeRanges?: InputMaybe<Array<TimeRangeEnum> | TimeRangeEnum>;
  untilDate: Scalars['Date']['input'];
  currency?: InputMaybe<Currency>;
}>;


export type GetSearchProductsQuery = { __typename?: 'Query', searchProducts: { __typename?: 'ProductsResult', records: Array<{ __typename?: 'Product', id: string, earliestAvailability?: any | null, poster?: string | null, duration: number, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean, originalPrice?: number | null } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', numReviews: number, average?: number | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, translation?: { __typename?: 'TagTranslation', name: string } | null } | null> | null, translation?: { __typename?: 'ProductTranslation', name: string, headline?: string | null } | null }> } };

export type GetTagOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagOptionsQuery = { __typename?: 'Query', tags: { __typename?: 'TagsResult', records: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type GetWaitingListUserQueryVariables = Exact<{
  accessKey: Scalars['ID']['input'];
}>;


export type GetWaitingListUserQuery = { __typename?: 'Query', waitingListUser: { __typename?: 'WaitingListUser', id?: string | null, email?: string | null, phoneNumber?: string | null, timeZone: string, waitingLists: Array<{ __typename?: 'WaitingList', id: string, productId: string, fromDate: any, untilDate: any, groupSize: number, active: boolean }> } };

export const BookingFieldsFragmentDoc = gql`
    fragment BookingFields on Booking {
  id
  created
  state
  didAttend
  email
  givenName
  familyName
  paymentAmount
  pickupLocation {
    address
    name
    query {
      placeId
      geoLocation {
        lat
        lng
      }
    }
  }
}
    `;
export const ChatMessageEventFieldsFragmentDoc = gql`
    fragment ChatMessageEventFields on ChatMessageEvent {
  id
  created
  type
  groupId
  bookingId
}
    `;
export const ChatMessageMediaFieldsFragmentDoc = gql`
    fragment ChatMessageMediaFields on ChatMessageMedia {
  id
  created
  messageId
  type
  url
}
    `;
export const ChatMessageFieldsFragmentDoc = gql`
    fragment ChatMessageFields on ChatMessage {
  id
  created
  chatRoomId
  bookingId
  backofficeUserId
  guideId
  eventId
  body
}
    `;
export const ChatRoomFieldsFragmentDoc = gql`
    fragment ChatRoomFields on ChatRoom {
  id
  created
  type
  bookingId
  guideId
}
    `;
export const LocationTranslationFieldsFragmentDoc = gql`
    fragment LocationTranslationFields on LocationTranslation {
  name
  metaTitle
  metaDescription
  lang
}
    `;
export const LocationFieldsFragmentDoc = gql`
    fragment LocationFields on Location {
  id
  parentId
  countryId
  slug
  timezone
  country {
    id
    name
  }
}
    `;
export const ProductAvailabilityTimeSlotsFieldsFragmentDoc = gql`
    fragment ProductAvailabilityTimeSlotsFields on ProductAvailability {
  date
  status
  timeSlots {
    time
    status
    groups {
      id
      seatsAvailable
      isEmpty
      isPrivate
      guides {
        id
        nickName
      }
    }
  }
}
    `;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on Product {
  id
  created
  lastUpdated
  duration
  poster
  meetingPlaceGoogleMapsUrl
  maximumInGroup
  numCustomers
  mainImage
  name
  cancellationLimit
  availabilityType
  meetingPlaceGoogleMapsQuery {
    placeId
    geoLocation {
      lat
      lng
    }
  }
}
    `;
export const ProductTranslationFieldsFragmentDoc = gql`
    fragment ProductTranslationFields on ProductTranslation {
  lang
  name
  headline
  highlights
  included
  notIncluded
  remarks
  meetingPlaceName
  meetingPlaceDescription
  featuredGuideComment
  itinerary
  cancellationPolicy
  ogTitle
  ogDescription
  metaDescription
}
    `;
export const ProductPriceFieldsFragmentDoc = gql`
    fragment ProductPriceFields on ProductPrice {
  amount
  currency
  excludeFromPrivateGroupCount
  id
  maximumPeople
  minimumPeople
  originalPrice
  vegetarian
}
    `;
export const TagFieldsFragmentDoc = gql`
    fragment TagFields on Tag {
  id
  created
  lastUpdated
  name
}
    `;
export const TagTranslationFieldsFragmentDoc = gql`
    fragment TagTranslationFields on TagTranslation {
  created
  lastUpdated
  lang
  name
}
    `;
export const ProductAvailabilityFieldsFragmentDoc = gql`
    fragment ProductAvailabilityFields on ProductAvailability {
  date
  status
}
    `;
export const ProductAvailabilityTimeFieldsFragmentDoc = gql`
    fragment ProductAvailabilityTimeFields on ProductAvailabilityTime {
  time
  status
}
    `;
export const ProductAvailabilityGroupFieldsFragmentDoc = gql`
    fragment ProductAvailabilityGroupFields on ProductAvailabilityGroup {
  id
  seatsAvailable
}
    `;
export const GuideFieldsFragmentDoc = gql`
    fragment GuideFields on Guide {
  id
  nickName
  profilePic
  introVideo
  languages {
    iso639_1
    name
  }
  media {
    type
    url
  }
  numTours
  numCustomers
}
    `;
export const GuideTranslationFieldsFragmentDoc = gql`
    fragment GuideTranslationFields on GuideTranslation {
  language
  description
  hobbies
}
    `;
export const ProductCollectionProductFieldsFragmentDoc = gql`
    fragment ProductCollectionProductFields on ProductCollection {
  products {
    records {
      ...ProductFields
      translation(lang: $lang) {
        ...ProductTranslationFields
      }
      mainPrice(currency: $currency) {
        ...ProductPriceFields
      }
      reviews {
        avgStars
        totalRecords
      }
      tags {
        ...TagFields
        translation(lang: $lang) {
          ...TagTranslationFields
        }
      }
      availability(fromDate: $fromDate, untilDate: $untilDate) {
        ...ProductAvailabilityFields
        timeSlots {
          ...ProductAvailabilityTimeFields
          groups {
            ...ProductAvailabilityGroupFields
            guides {
              ...GuideFields
              translation(lang: $lang) {
                ...GuideTranslationFields
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const ProductCollectionFieldsFragmentDoc = gql`
    fragment ProductCollectionFields on ProductCollection {
  id
  slug
  title
  listTitle
  metaTitle
  headline
  description
  listDescription
  metaDescription
  content
  imageUrl
  lastUpdated
  locations {
    id
  }
  tags {
    id
  }
}
    `;
export const ProductDetailMediaFieldsFragmentDoc = gql`
    fragment ProductDetailMediaFields on ProductDetailMedia {
  typeId
  mediaUrl
  type {
    type
  }
}
    `;
export const ProductDetailTranslationFieldsFragmentDoc = gql`
    fragment ProductDetailTranslationFields on ProductDetailTranslation {
  lang
  name
  story
}
    `;
export const ProductDietaryRestrictionsFieldsFragmentDoc = gql`
    fragment ProductDietaryRestrictionsFields on DietaryRestriction {
  diet
  memo
  isPossible
}
    `;
export const ProductDisplayPriceFieldsFragmentDoc = gql`
    fragment ProductDisplayPriceFields on ProductDisplayPrice {
  amount
  currency
  isGroup
  originalPrice
}
    `;
export const ProductFaqFieldsFragmentDoc = gql`
    fragment ProductFAQFields on ProductFAQ {
  id
  createdAt
  productId
  lang
  question
  answer
  index
  imageUrl
}
    `;
export const ProductInclusionTranslationFieldsFragmentDoc = gql`
    fragment ProductInclusionTranslationFields on ProductInclusionTranslation {
  lang
  title
  description
}
    `;
export const ProductInclusionFieldsFragmentDoc = gql`
    fragment ProductInclusionFields on ProductInclusion {
  id
  index
  icon
}
    `;
export const ProductMediaFieldsFragmentDoc = gql`
    fragment ProductMediaFields on ProductMedia {
  url
  type
  category {
    id
    name
  }
}
    `;
export const ProductPriceTranslationFieldsFragmentDoc = gql`
    fragment ProductPriceTranslationFields on ProductPriceTranslation {
  name
  description
}
    `;
export const ProductPrivatePriceFieldsFragmentDoc = gql`
    fragment ProductPrivatePriceFields on ProductPrivatePrice {
  id
  minGroupSize
  price
}
    `;
export const ProductYouTubeFieldsFragmentDoc = gql`
    fragment ProductYouTubeFields on ProductYouTube {
  youtubeId
  title
}
    `;
export const ReviewFieldsFragmentDoc = gql`
    fragment ReviewFields on Review {
  id
  text
  userName
  date
  stars
  profileImageUrl
  imageUrl
  isApprovedImage
  booking {
    group {
      date
    }
  }
}
    `;
export const DeleteAllWaitingListsDocument = gql`
    mutation DeleteAllWaitingLists($id: ID!) {
  deleteAllWaitingLists(id: $id) {
    id
  }
}
    `;
export type DeleteAllWaitingListsMutationFn = Apollo.MutationFunction<DeleteAllWaitingListsMutation, DeleteAllWaitingListsMutationVariables>;

/**
 * __useDeleteAllWaitingListsMutation__
 *
 * To run a mutation, you first call `useDeleteAllWaitingListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllWaitingListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllWaitingListsMutation, { data, loading, error }] = useDeleteAllWaitingListsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAllWaitingListsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllWaitingListsMutation, DeleteAllWaitingListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllWaitingListsMutation, DeleteAllWaitingListsMutationVariables>(DeleteAllWaitingListsDocument, options);
      }
export type DeleteAllWaitingListsMutationHookResult = ReturnType<typeof useDeleteAllWaitingListsMutation>;
export type DeleteAllWaitingListsMutationResult = Apollo.MutationResult<DeleteAllWaitingListsMutation>;
export type DeleteAllWaitingListsMutationOptions = Apollo.BaseMutationOptions<DeleteAllWaitingListsMutation, DeleteAllWaitingListsMutationVariables>;
export const DeleteWaitingListsDocument = gql`
    mutation DeleteWaitingLists($ids: [ID!]!) {
  deleteWaitingLists(ids: $ids) {
    id
  }
}
    `;
export type DeleteWaitingListsMutationFn = Apollo.MutationFunction<DeleteWaitingListsMutation, DeleteWaitingListsMutationVariables>;

/**
 * __useDeleteWaitingListsMutation__
 *
 * To run a mutation, you first call `useDeleteWaitingListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWaitingListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWaitingListsMutation, { data, loading, error }] = useDeleteWaitingListsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteWaitingListsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWaitingListsMutation, DeleteWaitingListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWaitingListsMutation, DeleteWaitingListsMutationVariables>(DeleteWaitingListsDocument, options);
      }
export type DeleteWaitingListsMutationHookResult = ReturnType<typeof useDeleteWaitingListsMutation>;
export type DeleteWaitingListsMutationResult = Apollo.MutationResult<DeleteWaitingListsMutation>;
export type DeleteWaitingListsMutationOptions = Apollo.BaseMutationOptions<DeleteWaitingListsMutation, DeleteWaitingListsMutationVariables>;
export const EditWaitingListDocument = gql`
    mutation EditWaitingList($input: EditWaitingListInput!) {
  editWaitingList(input: $input) {
    id
    productId
    fromDate
    untilDate
    groupSize
    active
    contacted
  }
}
    `;
export type EditWaitingListMutationFn = Apollo.MutationFunction<EditWaitingListMutation, EditWaitingListMutationVariables>;

/**
 * __useEditWaitingListMutation__
 *
 * To run a mutation, you first call `useEditWaitingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWaitingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWaitingListMutation, { data, loading, error }] = useEditWaitingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditWaitingListMutation(baseOptions?: Apollo.MutationHookOptions<EditWaitingListMutation, EditWaitingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWaitingListMutation, EditWaitingListMutationVariables>(EditWaitingListDocument, options);
      }
export type EditWaitingListMutationHookResult = ReturnType<typeof useEditWaitingListMutation>;
export type EditWaitingListMutationResult = Apollo.MutationResult<EditWaitingListMutation>;
export type EditWaitingListMutationOptions = Apollo.BaseMutationOptions<EditWaitingListMutation, EditWaitingListMutationVariables>;
export const EditWaitingListUserDocument = gql`
    mutation EditWaitingListUser($input: EditWaitingListUserInput!) {
  editWaitingListUser(input: $input) {
    timeZone
  }
}
    `;
export type EditWaitingListUserMutationFn = Apollo.MutationFunction<EditWaitingListUserMutation, EditWaitingListUserMutationVariables>;

/**
 * __useEditWaitingListUserMutation__
 *
 * To run a mutation, you first call `useEditWaitingListUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWaitingListUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWaitingListUserMutation, { data, loading, error }] = useEditWaitingListUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditWaitingListUserMutation(baseOptions?: Apollo.MutationHookOptions<EditWaitingListUserMutation, EditWaitingListUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWaitingListUserMutation, EditWaitingListUserMutationVariables>(EditWaitingListUserDocument, options);
      }
export type EditWaitingListUserMutationHookResult = ReturnType<typeof useEditWaitingListUserMutation>;
export type EditWaitingListUserMutationResult = Apollo.MutationResult<EditWaitingListUserMutation>;
export type EditWaitingListUserMutationOptions = Apollo.BaseMutationOptions<EditWaitingListUserMutation, EditWaitingListUserMutationVariables>;
export const SendChatMessageDocument = gql`
    mutation sendChatMessage($input: SendChatMessageInput!) {
  sendChatMessage(input: $input) {
    ...ChatMessageFields
    media {
      ...ChatMessageMediaFields
    }
  }
}
    ${ChatMessageFieldsFragmentDoc}
${ChatMessageMediaFieldsFragmentDoc}`;
export type SendChatMessageMutationFn = Apollo.MutationFunction<SendChatMessageMutation, SendChatMessageMutationVariables>;

/**
 * __useSendChatMessageMutation__
 *
 * To run a mutation, you first call `useSendChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChatMessageMutation, { data, loading, error }] = useSendChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendChatMessageMutation, SendChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendChatMessageMutation, SendChatMessageMutationVariables>(SendChatMessageDocument, options);
      }
export type SendChatMessageMutationHookResult = ReturnType<typeof useSendChatMessageMutation>;
export type SendChatMessageMutationResult = Apollo.MutationResult<SendChatMessageMutation>;
export type SendChatMessageMutationOptions = Apollo.BaseMutationOptions<SendChatMessageMutation, SendChatMessageMutationVariables>;
export const SignContractsDocument = gql`
    mutation signContracts($guideId: ID!, $signature: String!) {
  signContracts(guideId: $guideId, signature: $signature)
}
    `;
export type SignContractsMutationFn = Apollo.MutationFunction<SignContractsMutation, SignContractsMutationVariables>;

/**
 * __useSignContractsMutation__
 *
 * To run a mutation, you first call `useSignContractsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignContractsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signContractsMutation, { data, loading, error }] = useSignContractsMutation({
 *   variables: {
 *      guideId: // value for 'guideId'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useSignContractsMutation(baseOptions?: Apollo.MutationHookOptions<SignContractsMutation, SignContractsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignContractsMutation, SignContractsMutationVariables>(SignContractsDocument, options);
      }
export type SignContractsMutationHookResult = ReturnType<typeof useSignContractsMutation>;
export type SignContractsMutationResult = Apollo.MutationResult<SignContractsMutation>;
export type SignContractsMutationOptions = Apollo.BaseMutationOptions<SignContractsMutation, SignContractsMutationVariables>;
export const ToggleWaitingListDocument = gql`
    mutation ToggleWaitingList($id: ID!) {
  toggleWaitingList(id: $id)
}
    `;
export type ToggleWaitingListMutationFn = Apollo.MutationFunction<ToggleWaitingListMutation, ToggleWaitingListMutationVariables>;

/**
 * __useToggleWaitingListMutation__
 *
 * To run a mutation, you first call `useToggleWaitingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWaitingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWaitingListMutation, { data, loading, error }] = useToggleWaitingListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleWaitingListMutation(baseOptions?: Apollo.MutationHookOptions<ToggleWaitingListMutation, ToggleWaitingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleWaitingListMutation, ToggleWaitingListMutationVariables>(ToggleWaitingListDocument, options);
      }
export type ToggleWaitingListMutationHookResult = ReturnType<typeof useToggleWaitingListMutation>;
export type ToggleWaitingListMutationResult = Apollo.MutationResult<ToggleWaitingListMutation>;
export type ToggleWaitingListMutationOptions = Apollo.BaseMutationOptions<ToggleWaitingListMutation, ToggleWaitingListMutationVariables>;
export const GetAllCountriesDocument = gql`
    query getAllCountries($input: LocationsInput) {
  locations(input: $input) {
    records {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAllCountriesQuery__
 *
 * To run a query within a React component, call `useGetAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCountriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
      }
export function useGetAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
        }
export function useGetAllCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
        }
export type GetAllCountriesQueryHookResult = ReturnType<typeof useGetAllCountriesQuery>;
export type GetAllCountriesLazyQueryHookResult = ReturnType<typeof useGetAllCountriesLazyQuery>;
export type GetAllCountriesSuspenseQueryHookResult = ReturnType<typeof useGetAllCountriesSuspenseQuery>;
export type GetAllCountriesQueryResult = Apollo.QueryResult<GetAllCountriesQuery, GetAllCountriesQueryVariables>;
export const GetAllLocationIdsDocument = gql`
    query getAllLocationIds {
  locations {
    records {
      id
      slug
      country {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAllLocationIdsQuery__
 *
 * To run a query within a React component, call `useGetAllLocationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocationIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLocationIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>(GetAllLocationIdsDocument, options);
      }
export function useGetAllLocationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>(GetAllLocationIdsDocument, options);
        }
export function useGetAllLocationIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>(GetAllLocationIdsDocument, options);
        }
export type GetAllLocationIdsQueryHookResult = ReturnType<typeof useGetAllLocationIdsQuery>;
export type GetAllLocationIdsLazyQueryHookResult = ReturnType<typeof useGetAllLocationIdsLazyQuery>;
export type GetAllLocationIdsSuspenseQueryHookResult = ReturnType<typeof useGetAllLocationIdsSuspenseQuery>;
export type GetAllLocationIdsQueryResult = Apollo.QueryResult<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>;
export const GetAllProductOptionsDocument = gql`
    query getAllProductOptions {
  products {
    records {
      id
      translation(lang: en) {
        name
      }
      location {
        name
      }
    }
  }
}
    `;

/**
 * __useGetAllProductOptionsQuery__
 *
 * To run a query within a React component, call `useGetAllProductOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProductOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>(GetAllProductOptionsDocument, options);
      }
export function useGetAllProductOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>(GetAllProductOptionsDocument, options);
        }
export function useGetAllProductOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>(GetAllProductOptionsDocument, options);
        }
export type GetAllProductOptionsQueryHookResult = ReturnType<typeof useGetAllProductOptionsQuery>;
export type GetAllProductOptionsLazyQueryHookResult = ReturnType<typeof useGetAllProductOptionsLazyQuery>;
export type GetAllProductOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAllProductOptionsSuspenseQuery>;
export type GetAllProductOptionsQueryResult = Apollo.QueryResult<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>;
export const GetAvailableGuidesDocument = gql`
    query getAvailableGuides($productId: ID!, $lang: Iso639!, $fromDate: Date!, $untilDate: Date!) {
  product(id: $productId) {
    id
    availability(fromDate: $fromDate, untilDate: $untilDate) {
      ...ProductAvailabilityFields
      timeSlots {
        ...ProductAvailabilityTimeFields
        groups {
          ...ProductAvailabilityGroupFields
          guides {
            ...GuideFields
            translation(lang: $lang) {
              ...GuideTranslationFields
            }
            reviews {
              avgStars
              totalRecords
            }
          }
        }
      }
    }
  }
}
    ${ProductAvailabilityFieldsFragmentDoc}
${ProductAvailabilityTimeFieldsFragmentDoc}
${ProductAvailabilityGroupFieldsFragmentDoc}
${GuideFieldsFragmentDoc}
${GuideTranslationFieldsFragmentDoc}`;

/**
 * __useGetAvailableGuidesQuery__
 *
 * To run a query within a React component, call `useGetAvailableGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableGuidesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      lang: // value for 'lang'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *   },
 * });
 */
export function useGetAvailableGuidesQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables> & ({ variables: GetAvailableGuidesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>(GetAvailableGuidesDocument, options);
      }
export function useGetAvailableGuidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>(GetAvailableGuidesDocument, options);
        }
export function useGetAvailableGuidesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>(GetAvailableGuidesDocument, options);
        }
export type GetAvailableGuidesQueryHookResult = ReturnType<typeof useGetAvailableGuidesQuery>;
export type GetAvailableGuidesLazyQueryHookResult = ReturnType<typeof useGetAvailableGuidesLazyQuery>;
export type GetAvailableGuidesSuspenseQueryHookResult = ReturnType<typeof useGetAvailableGuidesSuspenseQuery>;
export type GetAvailableGuidesQueryResult = Apollo.QueryResult<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>;
export const GetBookingDocument = gql`
    query getBooking($bookingId: ID!) {
  booking(id: $bookingId) {
    id
    state
    paymentAmount
    currency
    email
    familyName
    givenName
    phoneNumber
    isPrivate
    created
    pickupLocation {
      query {
        placeId
        geoLocation {
          lat
          lng
        }
      }
      name
      address
    }
    group {
      date
      time
      guideAssignments {
        guide {
          id
          nickName
          profilePic
        }
      }
      product {
        minimumInGroup
        meetingPlaceGoogleMapsUrl
        meetingPlaceGoogleMapsQuery {
          placeId
          geoLocation {
            lat
            lng
          }
        }
        poster
        translation(lang: en) {
          name
          itinerary
          meetingPlaceDescription
          meetingPlaceName
        }
      }
    }
  }
}
    `;

/**
 * __useGetBookingQuery__
 *
 * To run a query within a React component, call `useGetBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingQuery(baseOptions: Apollo.QueryHookOptions<GetBookingQuery, GetBookingQueryVariables> & ({ variables: GetBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
      }
export function useGetBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
        }
export function useGetBookingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
        }
export type GetBookingQueryHookResult = ReturnType<typeof useGetBookingQuery>;
export type GetBookingLazyQueryHookResult = ReturnType<typeof useGetBookingLazyQuery>;
export type GetBookingSuspenseQueryHookResult = ReturnType<typeof useGetBookingSuspenseQuery>;
export type GetBookingQueryResult = Apollo.QueryResult<GetBookingQuery, GetBookingQueryVariables>;
export const GetBookingDetailsDocument = gql`
    query getBookingDetails($bookingId: ID!, $currency: Currency!, $lang: Iso639!) {
  booking(id: $bookingId) {
    details {
      quantity
      unitAmount(currency: $currency)
      productPrice {
        excludeFromPrivateGroupCount
        translation(lang: $lang) {
          name
          description
        }
      }
    }
  }
}
    `;

/**
 * __useGetBookingDetailsQuery__
 *
 * To run a query within a React component, call `useGetBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingDetailsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      currency: // value for 'currency'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetBookingDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetBookingDetailsQuery, GetBookingDetailsQueryVariables> & ({ variables: GetBookingDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>(GetBookingDetailsDocument, options);
      }
export function useGetBookingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>(GetBookingDetailsDocument, options);
        }
export function useGetBookingDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>(GetBookingDetailsDocument, options);
        }
export type GetBookingDetailsQueryHookResult = ReturnType<typeof useGetBookingDetailsQuery>;
export type GetBookingDetailsLazyQueryHookResult = ReturnType<typeof useGetBookingDetailsLazyQuery>;
export type GetBookingDetailsSuspenseQueryHookResult = ReturnType<typeof useGetBookingDetailsSuspenseQuery>;
export type GetBookingDetailsQueryResult = Apollo.QueryResult<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>;
export const GetBookingWithChatRoomDocument = gql`
    query getBookingWithChatRoom($bookingId: ID!) {
  booking(id: $bookingId) {
    id
    state
    paymentAmount
    currency
    email
    familyName
    givenName
    isPrivate
    created
    pickupLocation {
      query {
        placeId
        geoLocation {
          lat
          lng
        }
      }
      name
      address
    }
    chatRoom {
      ...ChatRoomFields
    }
    group {
      date
      time
      guideAssignments {
        role
        guide {
          id
          nickName
          profilePic
        }
      }
      product {
        minimumInGroup
        meetingPlaceGoogleMapsUrl
        meetingPlaceGoogleMapsQuery {
          placeId
          geoLocation {
            lat
            lng
          }
        }
        poster
        translation(lang: en) {
          name
          itinerary
          meetingPlaceDescription
          meetingPlaceName
        }
      }
    }
  }
}
    ${ChatRoomFieldsFragmentDoc}`;

/**
 * __useGetBookingWithChatRoomQuery__
 *
 * To run a query within a React component, call `useGetBookingWithChatRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingWithChatRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingWithChatRoomQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingWithChatRoomQuery(baseOptions: Apollo.QueryHookOptions<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables> & ({ variables: GetBookingWithChatRoomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>(GetBookingWithChatRoomDocument, options);
      }
export function useGetBookingWithChatRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>(GetBookingWithChatRoomDocument, options);
        }
export function useGetBookingWithChatRoomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>(GetBookingWithChatRoomDocument, options);
        }
export type GetBookingWithChatRoomQueryHookResult = ReturnType<typeof useGetBookingWithChatRoomQuery>;
export type GetBookingWithChatRoomLazyQueryHookResult = ReturnType<typeof useGetBookingWithChatRoomLazyQuery>;
export type GetBookingWithChatRoomSuspenseQueryHookResult = ReturnType<typeof useGetBookingWithChatRoomSuspenseQuery>;
export type GetBookingWithChatRoomQueryResult = Apollo.QueryResult<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>;
export const GetChatMessagesDocument = gql`
    query getChatMessages($bookingId: ID!, $limit: Int, $prevId: String, $nextId: String) {
  chatMessages(
    bookingId: $bookingId
    limit: $limit
    prevId: $prevId
    nextId: $nextId
  ) {
    messages {
      ...ChatMessageFields
      booking {
        ...BookingFields
      }
      guide {
        ...GuideFields
      }
      media {
        ...ChatMessageMediaFields
      }
    }
    totalCount
    hasMore
  }
}
    ${ChatMessageFieldsFragmentDoc}
${BookingFieldsFragmentDoc}
${GuideFieldsFragmentDoc}
${ChatMessageMediaFieldsFragmentDoc}`;

/**
 * __useGetChatMessagesQuery__
 *
 * To run a query within a React component, call `useGetChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessagesQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      limit: // value for 'limit'
 *      prevId: // value for 'prevId'
 *      nextId: // value for 'nextId'
 *   },
 * });
 */
export function useGetChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables> & ({ variables: GetChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
      }
export function useGetChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
        }
export function useGetChatMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
        }
export type GetChatMessagesQueryHookResult = ReturnType<typeof useGetChatMessagesQuery>;
export type GetChatMessagesLazyQueryHookResult = ReturnType<typeof useGetChatMessagesLazyQuery>;
export type GetChatMessagesSuspenseQueryHookResult = ReturnType<typeof useGetChatMessagesSuspenseQuery>;
export type GetChatMessagesQueryResult = Apollo.QueryResult<GetChatMessagesQuery, GetChatMessagesQueryVariables>;
export const NextAvailableGuidesDocument = gql`
    query NextAvailableGuides($input: NextAvailableGuidesInput!, $lang: Iso639!) {
  nextAvailableGuides(input: $input) {
    id
    date
    time
    mainGuide {
      id
      nickName
      profilePic
      introVideo
      numTours
      numCustomers
      translation(lang: $lang) {
        description
      }
    }
  }
}
    `;

/**
 * __useNextAvailableGuidesQuery__
 *
 * To run a query within a React component, call `useNextAvailableGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextAvailableGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextAvailableGuidesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useNextAvailableGuidesQuery(baseOptions: Apollo.QueryHookOptions<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables> & ({ variables: NextAvailableGuidesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>(NextAvailableGuidesDocument, options);
      }
export function useNextAvailableGuidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>(NextAvailableGuidesDocument, options);
        }
export function useNextAvailableGuidesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>(NextAvailableGuidesDocument, options);
        }
export type NextAvailableGuidesQueryHookResult = ReturnType<typeof useNextAvailableGuidesQuery>;
export type NextAvailableGuidesLazyQueryHookResult = ReturnType<typeof useNextAvailableGuidesLazyQuery>;
export type NextAvailableGuidesSuspenseQueryHookResult = ReturnType<typeof useNextAvailableGuidesSuspenseQuery>;
export type NextAvailableGuidesQueryResult = Apollo.QueryResult<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>;
export const GetProductDocument = gql`
    query getProduct($id: ID!, $currency: Currency, $lang: Iso639!) {
  product(id: $id) {
    ...ProductFields
    translation(lang: $lang) {
      ...ProductTranslationFields
    }
    prices(currency: $currency) {
      ...ProductPriceFields
    }
    privatePrices(currency: $currency) {
      ...ProductPrivatePriceFields
    }
    faqs(lang: $lang) {
      ...ProductFAQFields
    }
    featuredGuide {
      ...GuideFields
    }
    youtubes {
      ...ProductYouTubeFields
    }
    reviews {
      avgStars
      totalRecords
    }
    tags {
      ...TagFields
      translation(lang: $lang) {
        ...TagTranslationFields
      }
    }
    media {
      ...ProductMediaFields
    }
    details {
      media {
        ...ProductDetailMediaFields
      }
      translation(lang: $lang) {
        ...ProductDetailTranslationFields
      }
    }
    location {
      ...LocationFields
      translation(lang: $lang) {
        ...LocationTranslationFields
      }
    }
    inclusions {
      ...ProductInclusionFields
      translation(lang: $lang) {
        ...ProductInclusionTranslationFields
      }
    }
    dietaryRestrictions {
      ...ProductDietaryRestrictionsFields
    }
    recentPhotos
    hasAccomodationVehiclePickup
    hasDefaultVehiclePickup
    pickupLocationZone {
      center {
        lat
        lng
      }
      radius
    }
  }
}
    ${ProductFieldsFragmentDoc}
${ProductTranslationFieldsFragmentDoc}
${ProductPriceFieldsFragmentDoc}
${ProductPrivatePriceFieldsFragmentDoc}
${ProductFaqFieldsFragmentDoc}
${GuideFieldsFragmentDoc}
${ProductYouTubeFieldsFragmentDoc}
${TagFieldsFragmentDoc}
${TagTranslationFieldsFragmentDoc}
${ProductMediaFieldsFragmentDoc}
${ProductDetailMediaFieldsFragmentDoc}
${ProductDetailTranslationFieldsFragmentDoc}
${LocationFieldsFragmentDoc}
${LocationTranslationFieldsFragmentDoc}
${ProductInclusionFieldsFragmentDoc}
${ProductInclusionTranslationFieldsFragmentDoc}
${ProductDietaryRestrictionsFieldsFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *      currency: // value for 'currency'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables> & ({ variables: GetProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProductAvailabilitiesDocument = gql`
    query getProductAvailabilities($productId: ID!, $lang: Iso639!, $fromDate: Date!, $untilDate: Date!) {
  product(id: $productId) {
    availability(fromDate: $fromDate, untilDate: $untilDate) {
      ...ProductAvailabilityFields
      timeSlots {
        ...ProductAvailabilityTimeFields
        groups {
          ...ProductAvailabilityGroupFields
          guides {
            ...GuideFields
            translation(lang: $lang) {
              ...GuideTranslationFields
            }
          }
        }
      }
    }
  }
}
    ${ProductAvailabilityFieldsFragmentDoc}
${ProductAvailabilityTimeFieldsFragmentDoc}
${ProductAvailabilityGroupFieldsFragmentDoc}
${GuideFieldsFragmentDoc}
${GuideTranslationFieldsFragmentDoc}`;

/**
 * __useGetProductAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useGetProductAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductAvailabilitiesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      lang: // value for 'lang'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *   },
 * });
 */
export function useGetProductAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables> & ({ variables: GetProductAvailabilitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>(GetProductAvailabilitiesDocument, options);
      }
export function useGetProductAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>(GetProductAvailabilitiesDocument, options);
        }
export function useGetProductAvailabilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>(GetProductAvailabilitiesDocument, options);
        }
export type GetProductAvailabilitiesQueryHookResult = ReturnType<typeof useGetProductAvailabilitiesQuery>;
export type GetProductAvailabilitiesLazyQueryHookResult = ReturnType<typeof useGetProductAvailabilitiesLazyQuery>;
export type GetProductAvailabilitiesSuspenseQueryHookResult = ReturnType<typeof useGetProductAvailabilitiesSuspenseQuery>;
export type GetProductAvailabilitiesQueryResult = Apollo.QueryResult<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>;
export const GetProductCollectionDocument = gql`
    query getProductCollection($id: ID, $slug: String, $fromDate: Date!, $untilDate: Date!, $currency: Currency!, $lang: Iso639!) {
  productCollection(id: $id, slug: $slug) {
    ...ProductCollectionFields
    ...ProductCollectionProductFields
  }
}
    ${ProductCollectionFieldsFragmentDoc}
${ProductCollectionProductFieldsFragmentDoc}
${ProductFieldsFragmentDoc}
${ProductTranslationFieldsFragmentDoc}
${ProductPriceFieldsFragmentDoc}
${TagFieldsFragmentDoc}
${TagTranslationFieldsFragmentDoc}
${ProductAvailabilityFieldsFragmentDoc}
${ProductAvailabilityTimeFieldsFragmentDoc}
${ProductAvailabilityGroupFieldsFragmentDoc}
${GuideFieldsFragmentDoc}
${GuideTranslationFieldsFragmentDoc}`;

/**
 * __useGetProductCollectionQuery__
 *
 * To run a query within a React component, call `useGetProductCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *      currency: // value for 'currency'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetProductCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetProductCollectionQuery, GetProductCollectionQueryVariables> & ({ variables: GetProductCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCollectionQuery, GetProductCollectionQueryVariables>(GetProductCollectionDocument, options);
      }
export function useGetProductCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCollectionQuery, GetProductCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCollectionQuery, GetProductCollectionQueryVariables>(GetProductCollectionDocument, options);
        }
export function useGetProductCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductCollectionQuery, GetProductCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductCollectionQuery, GetProductCollectionQueryVariables>(GetProductCollectionDocument, options);
        }
export type GetProductCollectionQueryHookResult = ReturnType<typeof useGetProductCollectionQuery>;
export type GetProductCollectionLazyQueryHookResult = ReturnType<typeof useGetProductCollectionLazyQuery>;
export type GetProductCollectionSuspenseQueryHookResult = ReturnType<typeof useGetProductCollectionSuspenseQuery>;
export type GetProductCollectionQueryResult = Apollo.QueryResult<GetProductCollectionQuery, GetProductCollectionQueryVariables>;
export const GetProductCollectionsDocument = gql`
    query getProductCollections($id: ID!, $currency: Currency!, $lang: Iso639!, $fromDate: Date!, $untilDate: Date!) {
  productCollections {
    totalRecords
    records {
      ...ProductCollectionFields
      ...ProductCollectionProductFields
    }
  }
}
    ${ProductCollectionFieldsFragmentDoc}
${ProductCollectionProductFieldsFragmentDoc}
${ProductFieldsFragmentDoc}
${ProductTranslationFieldsFragmentDoc}
${ProductPriceFieldsFragmentDoc}
${TagFieldsFragmentDoc}
${TagTranslationFieldsFragmentDoc}
${ProductAvailabilityFieldsFragmentDoc}
${ProductAvailabilityTimeFieldsFragmentDoc}
${ProductAvailabilityGroupFieldsFragmentDoc}
${GuideFieldsFragmentDoc}
${GuideTranslationFieldsFragmentDoc}`;

/**
 * __useGetProductCollectionsQuery__
 *
 * To run a query within a React component, call `useGetProductCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCollectionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      currency: // value for 'currency'
 *      lang: // value for 'lang'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *   },
 * });
 */
export function useGetProductCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetProductCollectionsQuery, GetProductCollectionsQueryVariables> & ({ variables: GetProductCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>(GetProductCollectionsDocument, options);
      }
export function useGetProductCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>(GetProductCollectionsDocument, options);
        }
export function useGetProductCollectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>(GetProductCollectionsDocument, options);
        }
export type GetProductCollectionsQueryHookResult = ReturnType<typeof useGetProductCollectionsQuery>;
export type GetProductCollectionsLazyQueryHookResult = ReturnType<typeof useGetProductCollectionsLazyQuery>;
export type GetProductCollectionsSuspenseQueryHookResult = ReturnType<typeof useGetProductCollectionsSuspenseQuery>;
export type GetProductCollectionsQueryResult = Apollo.QueryResult<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>;
export const GetProductReviewsDocument = gql`
    query getProductReviews($id: ID!, $offset: Int, $limit: Int) {
  product(id: $id) {
    ...ProductFields
    reviews(offset: $offset, limit: $limit) {
      avgStars
      totalRecords
      records {
        ...ReviewFields
      }
    }
  }
}
    ${ProductFieldsFragmentDoc}
${ReviewFieldsFragmentDoc}`;

/**
 * __useGetProductReviewsQuery__
 *
 * To run a query within a React component, call `useGetProductReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductReviewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProductReviewsQuery(baseOptions: Apollo.QueryHookOptions<GetProductReviewsQuery, GetProductReviewsQueryVariables> & ({ variables: GetProductReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductReviewsQuery, GetProductReviewsQueryVariables>(GetProductReviewsDocument, options);
      }
export function useGetProductReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductReviewsQuery, GetProductReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductReviewsQuery, GetProductReviewsQueryVariables>(GetProductReviewsDocument, options);
        }
export function useGetProductReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductReviewsQuery, GetProductReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductReviewsQuery, GetProductReviewsQueryVariables>(GetProductReviewsDocument, options);
        }
export type GetProductReviewsQueryHookResult = ReturnType<typeof useGetProductReviewsQuery>;
export type GetProductReviewsLazyQueryHookResult = ReturnType<typeof useGetProductReviewsLazyQuery>;
export type GetProductReviewsSuspenseQueryHookResult = ReturnType<typeof useGetProductReviewsSuspenseQuery>;
export type GetProductReviewsQueryResult = Apollo.QueryResult<GetProductReviewsQuery, GetProductReviewsQueryVariables>;
export const GetProductsDocument = gql`
    query getProducts($productIds: [ID!], $locationId: ID, $currency: Currency, $fromDate: Date!, $untilDate: Date!, $groupSize: Int, $lang: Iso639!, $tagIds: [ID!], $timeRanges: [TimeRangeEnum!]) {
  products(input: {ids: $productIds, locationId: $locationId, tagIds: $tagIds}) {
    records {
      ...ProductFields
      prices(currency: $currency) {
        ...ProductPriceFields
      }
      translation(lang: $lang) {
        ...ProductTranslationFields
      }
      media {
        ...ProductMediaFields
      }
      reviews {
        avgStars
        totalRecords
      }
      tags {
        ...TagFields
        translation(lang: $lang) {
          ...TagTranslationFields
        }
      }
      mainPrice(currency: $currency) {
        amount
        currency
      }
      privatePrices(currency: $currency) {
        ...ProductPrivatePriceFields
      }
      availability(
        fromDate: $fromDate
        untilDate: $untilDate
        groupSize: $groupSize
        timeRanges: $timeRanges
      ) {
        date
        status
        timeSlots {
          time
          status
        }
      }
    }
  }
}
    ${ProductFieldsFragmentDoc}
${ProductPriceFieldsFragmentDoc}
${ProductTranslationFieldsFragmentDoc}
${ProductMediaFieldsFragmentDoc}
${TagFieldsFragmentDoc}
${TagTranslationFieldsFragmentDoc}
${ProductPrivatePriceFieldsFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *      locationId: // value for 'locationId'
 *      currency: // value for 'currency'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *      groupSize: // value for 'groupSize'
 *      lang: // value for 'lang'
 *      tagIds: // value for 'tagIds'
 *      timeRanges: // value for 'timeRanges'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables> & ({ variables: GetProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export function useGetProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductsSuspenseQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetSearchProductsDocument = gql`
    query getSearchProducts($fromDate: Date!, $groupSize: Int!, $lang: Iso639!, $locationId: ID, $tagIds: [ID!], $timeRanges: [TimeRangeEnum!], $untilDate: Date!, $currency: Currency) {
  searchProducts(
    input: {fromDate: $fromDate, groupSize: $groupSize, lang: $lang, locationId: $locationId, tagIds: $tagIds, timeRanges: $timeRanges, untilDate: $untilDate}
  ) {
    records {
      id
      earliestAvailability
      poster
      duration
      displayPrice(currency: $currency) {
        ...ProductDisplayPriceFields
      }
      reviewSummary {
        numReviews
        average
      }
      tags {
        id
        translation(lang: $lang) {
          name
        }
      }
      translation(lang: $lang) {
        name
        headline
      }
    }
  }
}
    ${ProductDisplayPriceFieldsFragmentDoc}`;

/**
 * __useGetSearchProductsQuery__
 *
 * To run a query within a React component, call `useGetSearchProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchProductsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      groupSize: // value for 'groupSize'
 *      lang: // value for 'lang'
 *      locationId: // value for 'locationId'
 *      tagIds: // value for 'tagIds'
 *      timeRanges: // value for 'timeRanges'
 *      untilDate: // value for 'untilDate'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetSearchProductsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchProductsQuery, GetSearchProductsQueryVariables> & ({ variables: GetSearchProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchProductsQuery, GetSearchProductsQueryVariables>(GetSearchProductsDocument, options);
      }
export function useGetSearchProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchProductsQuery, GetSearchProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchProductsQuery, GetSearchProductsQueryVariables>(GetSearchProductsDocument, options);
        }
export function useGetSearchProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchProductsQuery, GetSearchProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchProductsQuery, GetSearchProductsQueryVariables>(GetSearchProductsDocument, options);
        }
export type GetSearchProductsQueryHookResult = ReturnType<typeof useGetSearchProductsQuery>;
export type GetSearchProductsLazyQueryHookResult = ReturnType<typeof useGetSearchProductsLazyQuery>;
export type GetSearchProductsSuspenseQueryHookResult = ReturnType<typeof useGetSearchProductsSuspenseQuery>;
export type GetSearchProductsQueryResult = Apollo.QueryResult<GetSearchProductsQuery, GetSearchProductsQueryVariables>;
export const GetTagOptionsDocument = gql`
    query getTagOptions {
  tags(hasProducts: true) {
    records {
      id
      name
    }
  }
}
    `;

/**
 * __useGetTagOptionsQuery__
 *
 * To run a query within a React component, call `useGetTagOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagOptionsQuery, GetTagOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagOptionsQuery, GetTagOptionsQueryVariables>(GetTagOptionsDocument, options);
      }
export function useGetTagOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagOptionsQuery, GetTagOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagOptionsQuery, GetTagOptionsQueryVariables>(GetTagOptionsDocument, options);
        }
export function useGetTagOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagOptionsQuery, GetTagOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagOptionsQuery, GetTagOptionsQueryVariables>(GetTagOptionsDocument, options);
        }
export type GetTagOptionsQueryHookResult = ReturnType<typeof useGetTagOptionsQuery>;
export type GetTagOptionsLazyQueryHookResult = ReturnType<typeof useGetTagOptionsLazyQuery>;
export type GetTagOptionsSuspenseQueryHookResult = ReturnType<typeof useGetTagOptionsSuspenseQuery>;
export type GetTagOptionsQueryResult = Apollo.QueryResult<GetTagOptionsQuery, GetTagOptionsQueryVariables>;
export const GetWaitingListUserDocument = gql`
    query getWaitingListUser($accessKey: ID!) {
  waitingListUser(accessKey: $accessKey) {
    id
    email
    phoneNumber
    timeZone
    waitingLists {
      id
      productId
      fromDate
      untilDate
      groupSize
      active
    }
  }
}
    `;

/**
 * __useGetWaitingListUserQuery__
 *
 * To run a query within a React component, call `useGetWaitingListUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitingListUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitingListUserQuery({
 *   variables: {
 *      accessKey: // value for 'accessKey'
 *   },
 * });
 */
export function useGetWaitingListUserQuery(baseOptions: Apollo.QueryHookOptions<GetWaitingListUserQuery, GetWaitingListUserQueryVariables> & ({ variables: GetWaitingListUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>(GetWaitingListUserDocument, options);
      }
export function useGetWaitingListUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>(GetWaitingListUserDocument, options);
        }
export function useGetWaitingListUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>(GetWaitingListUserDocument, options);
        }
export type GetWaitingListUserQueryHookResult = ReturnType<typeof useGetWaitingListUserQuery>;
export type GetWaitingListUserLazyQueryHookResult = ReturnType<typeof useGetWaitingListUserLazyQuery>;
export type GetWaitingListUserSuspenseQueryHookResult = ReturnType<typeof useGetWaitingListUserSuspenseQuery>;
export type GetWaitingListUserQueryResult = Apollo.QueryResult<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>;